import React from 'react';
import { AlertTriangleIcon } from 'lucide-react';
import { CtaBlock } from './CtaBlock';
const TOTAL_SPOTS = 100;
const SPOTS_LEFT = 7;
const FILLED = TOTAL_SPOTS - SPOTS_LEFT;
export function Scarcity() {
  return <section className="border-t border-ink-700 bg-ink-950 px-4 py-12 sm:px-6 sm:py-16" data-id="element-224" data-mp="20ke49rwqrxal">
      <div className="mx-auto w-full max-w-2xl rounded-2xl border border-bad/40 bg-bad/[0.07] p-5 sm:p-7" data-id="element-225" data-mp="1wjkfyxfe0gh6">
        <div className="flex items-center justify-center gap-2" data-id="element-226" data-mp="18vawi25nc4t7">
          <AlertTriangleIcon className="h-5 w-5 shrink-0 text-bad" aria-hidden="true" data-id="element-227" data-mp="13vesw40v2fe6" />
          <p className="text-[11px] font-bold uppercase tracking-[0.18em] text-bad sm:text-xs" data-id="element-228" data-mp="1hmjl4l1wg5eh">
            Das Angebot ist fast ausverkauft
          </p>
        </div>

        <h2 className="mt-3 text-center font-display text-[26px] uppercase leading-tight text-white sm:text-3xl" data-id="element-229" data-mp="1cujr198ig6pt">
          Nur noch {SPOTS_LEFT} Plätze verfügbar
        </h2>

        <div className="mt-5" data-id="element-230" data-mp="l3lws0qhwe28">
          <div className="h-3.5 w-full overflow-hidden rounded-full bg-ink-700" role="progressbar" aria-valuenow={FILLED} aria-valuemin={0} aria-valuemax={TOTAL_SPOTS} aria-label="Vergebene Plätze zum Einführungspreis" data-id="element-231" data-mp="l2kog40v65o7">
            <div className="h-full rounded-full bg-brand" style={{
            width: `${FILLED / TOTAL_SPOTS * 100}%`
          }} data-id="element-232" data-mp="3b9opan04f7ns" />
          </div>
          <div className="mt-2 flex items-center justify-between text-xs font-semibold text-white/60" data-id="element-233" data-mp="2ik80dzbpm8wb">
            <span data-id="element-234" data-mp="2nijc6flketh6">{FILLED} von {TOTAL_SPOTS} Plätzen vergeben</span>
            <span className="text-bad" data-id="element-235" data-mp="2sgumerfrv5zx">Nur noch {SPOTS_LEFT} frei</span>
          </div>
        </div>

        <p className="mt-4 text-center text-[15px] leading-relaxed text-white/70" data-id="element-236" data-mp="2xggyuyns0i7o">
          Es bleiben nur noch {SPOTS_LEFT} Plätze, bevor der Einführungspreis endet.
        </p>

        <CtaBlock label="Ich will das Meister-Schweisssystem" className="mt-6" data-id="element-237" data-mp="cppz7pg98vk2" />
      </div>
    </section>;
}